import { Injectable } from '@angular/core';
import { UNITS, CURRENCY_CODE } from '../../constants/currency-units';
import { QUALIFICATION_CODES } from '../../constants/qualification-code';
import { Criteria } from '../../interfaces/quota.interface';
import { ChildrenLabelMapper } from 'purespectrum-lib';
@Injectable({
  providedIn: 'root',
})
export class QuotaService {
  constructor() {}

  breakArrayAndJoinQuotaViewItem(input: Criteria[]) {
    const retArr: string[] = [];
    const units = UNITS;
    input.forEach((item: Criteria) => {
      if (item.qualification_code === QUALIFICATION_CODES.CHILD_AGE_GENDER) {
        const mapper = new ChildrenLabelMapper(
          item.condition_codes!.map(Number)
        );
        retArr.push(mapper.label());
      } else if (
        item.condition_names &&
        item.condition_names.length &&
        (!item.range_sets || (item.range_sets && !item.range_sets.length))
      ) {
        item.condition_names.forEach((name: string) => {
          retArr.push(name);
        });
      }
      if (item.range_sets && item.range_sets.length) {
        item.range_sets.forEach((rangeItem: any) => {
          // 321=USA $ & 324 = AU $ defined in dasboard constant file
          if (
            parseInt(rangeItem.units) >= CURRENCY_CODE.US &&
            parseInt(rangeItem.units) <= CURRENCY_CODE.AU
          ) {
            retArr.push(
              units[rangeItem.units] +
                parseInt(rangeItem.from) +
                ' - ' +
                units[rangeItem.units] +
                parseInt(rangeItem.to)
            );
          } else {
            retArr.push(
              parseInt(rangeItem.from) +
                ' ' +
                units[rangeItem.units] +
                ' - ' +
                parseInt(rangeItem.to) +
                ' ' +
                units[rangeItem.units]
            );
          }
        });
      }
    });
    return retArr.toString();
  }
}
